import {Routes, Route, Navigate} from 'react-router-dom';
import Layout from "./Layout";
import SiteSettings from "./SiteSettings";
import Experiences from "./experiences/Experiences";
import Bookings from "./bookings/Bookings";
import UpcomingEvents from "./upcomingEvents/UpcomingEvents";
import Experience from "./experiences/Experience";
import AddEvents from "./experiences/AddEvents";
import Edit from "./experiences/Edit";
import Booking from "./bookings/Booking";
import Event from "./upcomingEvents/Event";
import OverrideSettings from "./upcomingEvents/OverrideSettings";
import Create from "./experiences/Create";
import BundleCreate from "./bundles/Create";
import BundleView from "./bundles/View";
import WalletPackages from "../../admin/walletPackages";
import WalletTransactions from "../../admin/walletTransactions";
import DiscountCodes from "../../admin/discountCodes";
import AdminHealthScreening from "../../admin/healthScreening";
import Users from "./users/Users";
import User from "./users/User";

const ExperiencesAdminRouter = () => {
    return <Routes>
        <Route path="/" element={<Layout />}>
            <Route path="/upcoming-events/:id" element={<Event />} />
            <Route path="/upcoming-events/:id/override-settings" element={<OverrideSettings />} />
            <Route path="/upcoming-events" element={<UpcomingEvents />} />
            <Route path="/site-settings" element={<SiteSettings />} />
            <Route path="/wallet-packages" element={<WalletPackages.Template />}>
                <Route path="" element={<WalletPackages.List />} />
                <Route path="create" element={<WalletPackages.Create />} />
                <Route path=":id" element={<WalletPackages.Update />} />
            </Route>
            <Route path="/wallet-transactions" element={<WalletTransactions.Template />}>
                <Route path="" element={<WalletTransactions.List />} />
            </Route>
            <Route path="/experiences/create" element={<Create />} />
            <Route path="/experiences/:id/add-events" element={<AddEvents />} />
            <Route path="/experiences/:id/bundles/create" element={<BundleCreate />} />
            <Route path="/experiences/:id/bundles/:bundleId" element={<BundleView />} />
            <Route path="/experiences/:id/edit" element={<Edit />} />
            <Route path="/experiences/:id" element={<Experience />} />
            <Route path="/experiences" element={<Experiences />} />
            <Route path="/class-bookings/:id" element={<Booking />} />
            <Route path="/class-bookings" element={<Bookings />} />
            <Route path="/bookings/:id" element={<Booking />} />
            <Route path="/bookings" element={<Bookings />} />
            <Route path="/users/:id" element={<User />} />
            <Route path="/users" element={<Users />} />
            <Route path="/discount-codes" element={<DiscountCodes.Template />}>
                <Route path="" element={<DiscountCodes.List />} />
                <Route path="create" element={<DiscountCodes.Create />} />
                <Route path=":id" element={<DiscountCodes.Update />} />
            </Route>
            <Route path="/health-screening" element={<AdminHealthScreening.Template />}>
                <Route path="" element={<AdminHealthScreening.List />} />
                <Route path="questions" element={<AdminHealthScreening.Questions />} />
            </Route>
            <Route path="/" element={<Navigate to="/admin/upcoming-events" />} />
        </Route>
    </Routes>
}

export default ExperiencesAdminRouter
